.ytIframe {
  aspect-ratio: 16 / 9;
  border: 0;
  width: 100%;
}
